module.exports = __webpack_public_path__ + "static/media/infoJumbo3.e4ec4d4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/davi/images/infoJumbo3.jpg
// module id = 512
// module chunks = 0